'use client';
import AppIcon from '../../../App/AppIcon';
import { useState } from 'react';
import { Controller } from 'react-hook-form';
import './style.css';

type Props = {
  label?: string;
  name: string;
  control: any;
  error?: string;
  className?: string;
  containerClassName?: string;
  onlyNumber?: boolean;
  maxLength?: number;
  type?: 'normal' | 'number' | 'hour' | 'password' | 'currency' | 'time' | 'date' | 'phone';
  required?: boolean;
  placeholder?: string;
  disabled?: boolean;
  onCustomChange?: (value: string) => void;
  handleOpenHelper?: () => void;
  helperText?: string;
};

const ControlledText = ({
  label,
  name,
  control,
  error,
  className,
  containerClassName,
  onlyNumber,
  maxLength,
  type,
  required,
  placeholder,
  disabled,
  onCustomChange,
  handleOpenHelper,
  helperText,
}: Props) => {
  const [seePass, setSeePass] = useState(false);

  const handleValidation = (value: string) => {
    if ((onlyNumber || type === 'number') && !/^[0-9]*$/.test(value)) {
      return false;
    }

    if (type === 'currency') {
      if (value === '') return value;
      if (!/^\d*(,\d{0,2})?$/.test(value)) {
        return false;
      }
    }

    if (type === 'hour') {
      if (value.length > 5) {
        return false;
      }

      if (value.length === 2 && !value.includes(':')) {
        return `${value}:`;
      }

      if (value.length === 2 && value.includes(':')) {
        return false;
      }

      if (value.length === 3 && value.includes(':')) {
        return `${value[0]}${value[2]}:`;
      }

      if (value.length === 5 && value.includes(':')) {
        return `${value[0]}${value[1]}:${value[3]}${value[4]}`;
      }
    }

    if (type === 'phone') {
      // Remove tudo que não for número
      let digits = value.replace(/\D/g, '');
      if (digits.length > 11) digits = digits.slice(0, 11);
      let masked = '';
      if (digits.length > 0) masked = digits.slice(0, 2);
      if (digits.length >= 3) masked += ' ' + digits.slice(2, 7);
      if (digits.length >= 8) masked += '-' + digits.slice(7, 11);
      return masked;
    }

    return value;
  };

  return (
    <>
      <div className={`controlled-text-container ${containerClassName || ''}`}>
        <label htmlFor={name} className={`controlled-text-label ${error ? 'error' : ''}`}>
          {label}
          {required && <span className="controlled-text-required"> *</span>}
        </label>
        {/* {helperText && <Tooltip target={`.helper-${name}`} content={helperText} />} */}
        {handleOpenHelper && (
          <AppIcon
            icon="mdi:help-circle-outline"
            className={`controlled-text-helper helper-${name}`}
            width={30}
            onClick={handleOpenHelper}
          />
        )}
        <Controller
          name={name}
          control={control}
          render={({ field: { onChange, value } }) => (
            <input
              className={`controlled-text-input ${className || ''} ${error ? 'error' : ''} ${disabled ? 'disabled' : ''}`}
              id={name}
              value={value || ''}
              type={type === 'password' ? (seePass ? 'text' : type) : type === 'time' || type === 'date' ? type : 'text'}
              onChange={(e) => {
                const validatedValue = handleValidation(e.target.value);
                if (validatedValue !== false) {
                  onChange(validatedValue);
                  onCustomChange && onCustomChange(validatedValue);
                }
              }}
              maxLength={maxLength}
              placeholder={placeholder}
              disabled={disabled}
            />
          )}
        />
        {type === 'password' && (
          <AppIcon
            icon={seePass ? 'mdi:eye-off' : 'mdi:eye'}
            className="controlled-text-password-toggle"
            width={30}
            onClick={() => setSeePass(!seePass)}
          />
        )}
        {error && <small className="controlled-text-error">{error}</small>}
      </div>
    </>
  );
};

export default ControlledText;
